var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { readToken_ExternalId, createActivityOffChain } from './utility';
import { ActivityType } from './types';
function getAPIList(tokenService, offChainTokenService) {
    return {
        GET: {
            getBalance: `${tokenService}/user/balance`,
        },
        POST: {
            createToken: `${tokenService}/token/new`,
            transferToken: `${tokenService}/token/transfer`,
            topUp: `${tokenService}/user/reload`,
            createToken_offChain: `${offChainTokenService}/api/token/tokens`,
            envdDraft: `${offChainTokenService}/api/nlis/eNVD/draft`,
            validate: `${offChainTokenService}/api/nlis/validation`,
            uploadToS3: `${offChainTokenService}/api/uploader/s3`,
            createActivity: `${offChainTokenService}/api/token/activities`,
            getTokenByExId: `${offChainTokenService}/api/token/tokens/externalid`,
            getTokenById: `${offChainTokenService}/api/token/tokens/tokenid`,
            getTokenByUser: `${offChainTokenService}/api/token/tokens/userid`,
            getDocument: `${offChainTokenService}/api/document/get`,
        },
        PUT: {
            consignUpdate: `${offChainTokenService}/api/nlis/consignments`,
            // walletConnect off-chain operation
            updateAssets: `${offChainTokenService}/api/token/tokens/tokenid`,
        },
        SOCKET: {
            socketURL: tokenService,
        },
    };
}
export function featchAllUsers(userId, tokenService, offChainTokenService, authToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const userResponse = yield readToken_ExternalId([{ userId }], { url: getAPIList(tokenService, offChainTokenService).POST.getTokenByExId, authToken }, true);
            const businessId = userResponse[0].details.businessId;
            if (businessId) {
                const businessReponse = yield readToken_ExternalId([{ agliveToken: businessId }], { url: getAPIList(tokenService, offChainTokenService).POST.getTokenByExId, authToken }, true);
                return businessReponse[0];
            }
            else
                return null;
        }
        catch (e) {
            throw e;
        }
    });
}
export function addUser(userId, businessId, info, tokenService, offChainTokenService, authToken) {
    try {
        const tokens = [{
                type: 'business',
                tokenId: '',
                externalIds: { ["agliveToken"]: businessId },
            }];
        const newActivites = [{
                type: ActivityType.INVITE_USER,
                details: {
                    name: info.name,
                    role: info.role,
                    phone: info.phone,
                    email: info.email,
                },
            }];
        return createActivityOffChain(userId, tokens, newActivites, { url: getAPIList(tokenService, offChainTokenService).POST.createActivity, authToken });
    }
    catch (e) {
        throw e;
    }
}
;
export function inviteUserAgain(userId, businessId, invitationCode, tokenService, offChainTokenService, authToken) {
    try {
        const tokens = [{
                type: 'business',
                tokenId: '',
                externalIds: { ["agliveToken"]: businessId },
            }];
        const newActivites = [{
                type: ActivityType.INVITE_USER,
                details: {
                    invitationCode
                },
            }];
        return createActivityOffChain(userId, tokens, newActivites, { url: getAPIList(tokenService, offChainTokenService).POST.createActivity, authToken });
    }
    catch (e) {
        throw e;
    }
}
export function editUser(userId, businessId, info, ifRole, /**if role change, isRole should be true*/ ifActive, /** if active the user, isActive should be true*/ ifDeactivate, /** if deactive the user, ifDeactive should be true*/ tokenService, offChainTokenService, authToken, ifPending) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            //update user info under business
            const tokens = [{
                    type: 'business',
                    tokenId: '',
                    externalIds: { ["agliveToken"]: businessId },
                }];
            const newActivites = [{
                    type: ActivityType.UPDATE_USER,
                    details: {
                        // userId:info.userId,
                        name: info.name,
                        phone: info.phone,
                        email: info.email,
                    },
                }];
            if (ifRole) {
                newActivites[0].details["role"] = info.role;
            }
            if (ifPending) {
                newActivites[0].details["invitationCode"] = info.userId;
            }
            else {
                newActivites[0].details["userId"] = info.userId;
            }
            yield createActivityOffChain(userId, tokens, newActivites, { url: getAPIList(tokenService, offChainTokenService).POST.createActivity, authToken });
            if (ifActive) {
                const activityActivites = [{
                        type: ActivityType.ACTIVATE_USER,
                        details: {
                            userId: info.userId,
                        },
                    }];
                yield createActivityOffChain(userId, tokens, activityActivites, { url: getAPIList(tokenService, offChainTokenService).POST.createActivity, authToken });
            }
            if (ifDeactivate) {
                const deactivityActivites = [{
                        type: ActivityType.DEACTIVE_USER,
                        details: {
                            userId: info.userId,
                        },
                    }];
                yield createActivityOffChain(userId, tokens, deactivityActivites, { url: getAPIList(tokenService, offChainTokenService).POST.createActivity, authToken });
            }
        }
        catch (e) {
            throw e;
        }
    });
}
